<template>
    <div>
        <v-row class="px-2 pt-2">
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    @change="getReport(); loading = true;"
                ></v-autocomplete>
            </v-col>
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                >
                    <template v-slot:item.successful="{ item }">
                        {{ item.successful }}<br>
                        {{ item.successRatio }}%
                    </template>
                    <template v-slot:item.failed="{ item }">
                        {{ item.failed }}<br>
                        {{ item.failureRatio }}%
                    </template>
                    <template v-slot:item.limitExceeded="{ item }">
                        {{ item.limitExceeded }}<br>
                        {{ item.limitExceededRatio ? item.limitExceededRatio : 0.00 }}%
                    </template>
                    <template v-slot:item.doNotHonor="{ item }">
                        {{ item.doNotHonor }}<br>
                        {{ item.doNotHonorRatio ? item.doNotHonorRatio : 0.00 }}%
                    </template>
                    <template v-slot:item.successfulDebit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.successfulDebit) }}<br>
                        {{ item.successfulDbRatio }}%
                    </template>
                    <template v-slot:item.failedDebit="{ item }">
                        {{ new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(item.failedDebit) }}<br>
                        {{ item.failedDbRatio }}%
                    </template>
                    <template v-slot:item.visa="{ item }">
                        {{ item.visa}}<br>
                        {{ item.visaRatio }}%
                    </template>
                    <template v-slot:item.master="{ item }">
                        {{ item.master }}<br>
                        {{ item.masterRatio }}%
                    </template>
                
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
           merchants: null,
           merchant: null,
           loading: false,
           report: null,
           headers: [{ text: 'Date', value: 'date', sortable: false },
                     { text: 'Total Transactions', value: 'totalTransactions', sortable: false, align: "center" },
                     { text: 'Successful', value: 'successful', sortable: false, align: "center" },
                     { text: 'Failed', value: 'failed', sortable: false, align: "center" },
                     { text: 'Limit Exceeded', value: 'limitExceeded', sortable: false, align: "center" },
                     { text: 'Do Not Honor', value: 'doNotHonor', sortable: false, align: "center" },
                     { text: 'Successful Debit', value: 'successfulDebit', sortable: false, align: "center" },
                     { text: 'Failed Debit', value: 'failedDebit', sortable: false, align: "center" },
                     { text: 'Visa', value: 'visa', sortable: false, align: "center" },
                     { text: 'Master', value: 'master', sortable: false, align: "center" }]
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.merchant = this.merchants.length == 1 ? this.merchants[0] : null;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            axios({
            method: 'post',
            url: `transactions-analysis`,
            data: { merchant: this.merchant },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        }
    }
}
</script>